import {Grundstueck} from "./grundstueck";

export class Projekt {
    class = "Projekt";
    bagenr: string;
    prznummern: number[] = [];
    gegenstand: string;
    status: string;
    attributes: any;
    geometry: any;
    grundstuecke: Grundstueck[] = [];
    data?: any;
}
